import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { Grid, Typography, List, ListItem, Button, Divider, Link, Modal } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { SettingsDashboardPropTypes } from 'src/interfaces/iproptypes';
import { BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT, COLOR_PRIMARY_DARK } from 'src/const';
import { callApi } from 'src/core/callApi';
import { SearchRegion, RegionAccessPeriod } from 'src/interfaces/idashboard';
import { makeLowerCase } from 'src/utils/functions';
import { useSelector } from 'react-redux';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: '80vh',
      padding: '20px',
    },
    customButton: {
      background: COLOR_PRIMARY_DARK, //`radial-gradient(circle, hsla(189, 96%, 29%, 1) 0%, hsla(178, 100%, 38%, 1) 100%);`,
      borderRadius: 5,
      border: 70,
      color: 'white',
      height: 45,
      padding: '0 15px',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT,
      },
    },
    customButtonReversed: {
      background: BACKGROUND_COLOR, //`radial-gradient(circle, hsla(189, 96%, 29%, 1) 0%, hsla(178, 100%, 38%, 1) 100%);`,
      borderRadius: 5,
      border: 70,
      color: COLOR_PRIMARY_DARK,
      height: 45,
      padding: '0 15px',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT,
      },
    },
    modal: {
      position: 'absolute',
      backgroundColor: BACKGROUND_COLOR,
      padding: theme.spacing(4),
      borderRadius: 10,
      [theme.breakpoints.up('xs')]: {
        width: 350,
      },
    },
  })
);

const getRegionLink = (region): string => {
  const disctrictParam = region.name ? makeLowerCase(region.name) : '';
  const cityParam = region.city ? makeLowerCase(region.city) : '0';
  const countryParam = region.country ? makeLowerCase(region.country) : '0';
  return `https://app.airbtics.com/airbnb-data/${countryParam}/${cityParam}/${disctrictParam}`;
};

const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const SettingsDashboard = ({ user, getUserInfo }: SettingsDashboardPropTypes) => {
  const classes = useStyles();
  const customer = useSelector((state: any) => state.dashboard.user.customerID);
  const [url, setUrl] = useState('');

  useEffect(() => {
    getUserInfo();
  }, []);

  let regions: RegionAccessPeriod[] = [] as RegionAccessPeriod[];
  // const [showUnsubscribeModal, setShowUnsubscribeModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchURL = async () => {
      const URL =
        'https://rysmddj6h7.execute-api.us-east-2.amazonaws.com/default/getStripeCustomerPortalURL';
      const data = await callApi(URL, { body: { customerID: customer } }, false, false, '', 'POST');
      console.log('URL', data.url);
      setUrl(data.url);
    };

    fetchURL();
  }, [customer]);

  const handleManageBilling = () => {
    window.open(url, '_blank');
  };

  if (user.regions) {
    user.regions.forEach((region: string | SearchRegion) => {
      if (typeof region === 'string') {
        regions.push({
          name: region,
          daysLeft: '',
          city: region,
          country: region,
        });
      } else {
        const endedAtDate: Date = new Date(region.ended_at_dates[region.ended_at_dates.length - 1]);
        // calculate difference in days between endedAtDate and today
        const daysLeft: number = moment(endedAtDate).diff(moment(), 'days');
        regions.push({
          name: region.region,
          daysLeft: daysLeft > 0 ? `- ${daysLeft} days left` : '- Expired',
          city: region.city,
          country: region.country,
        });
      }
    });
  }

  return (
    <>
      <Grid container direction="column" justifyContent="flex-start" className={classes.container}>
        {/* <Grid item style={{marginBottom: '40px'}}>
          <Alert severity="warning">
            Attention: Due to an issue, markets created before October 17th may be inaccessible.
            Please create a new market. For additional credits, contact support@airbtics.com. We
            apologize for the inconvenience.
          </Alert>
        </Grid> */}
        <Grid item>
          <Typography variant="h5" style={{ marginBottom: 10 }}>
            Your Unlocked Markets
          </Typography>
          <Divider />
          {user.regions && (
            <List>
              {regions.map((region, index) => (
                <ListItem key={index}>
                  <Typography>
                    <Link href={getRegionLink(region)} target="_blank">
                      {capitalizeFirstLetter(region.name)}
                    </Link>{' '}
                    {region.daysLeft ? region.daysLeft : ''}
                  </Typography>
                </ListItem>
              ))}
            </List>
          )}
        </Grid>

        {customer && !loading && url !== 'invalid customerID' && (
          <Grid item>
            <Button
              className={classes.customButton}
              style={{ width: 150 }}
              onClick={handleManageBilling}
            >
              Manage Billing
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SettingsDashboard;
